import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_DETAIL_RESET,
  USER_ADD_REQUEST,
  USER_ADD_SUCCESS,
  USER_ADD_FAIL,
  // medecin PS
  MEDECIN_PS_LOGIN_REQUEST,
  MEDECIN_PS_LOGIN_SUCCESS,
  MEDECIN_PS_LOGIN_FAIL,
  MEDECIN_PS_LOGOUT,
  MEDECIN_PS_DETAIL_RESET,
} from "../constants/user_constant";
// patient
export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { loading: true };

    case USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };

    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };

    case USER_LOGOUT:
      return {};
    case USER_DETAIL_RESET:
      return {};

    default:
      return state;
  }
};

export const userRegisterReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case USER_ADD_REQUEST:
      return { loading: true };
    case USER_ADD_SUCCESS:
      return { loading: false, userInfo: action.payload, success1: true };
    case USER_ADD_FAIL:
      return { loading: false, error: action.payload };
    case USER_LOGOUT:
      return {};

    default:
      return state;
  }
};

// export const usersListReducers = (state = { users: [] }, action) => {
//     switch (action.type) {
//       case USER_ALL_REQUEST:
//         return { loading: true };
//       case USER_ALL_SUCCESS:
//         return { loading: false, users: action.payload };
//       case USER_ALL_FAIL:
//         return { loading: false, error: action.payload };

//       default:
//         return state;
//     }
//   };

// export const userUpdateReducer = (state = {}, action) => {
//     switch (action.type) {
//         case USER_UPDATE_REQUEST:
//             return { loading: true }

//         case USER_UPDATE_SUCCESS:
//             return { loading: false, success:action.payload }

//         case USER_UPDATE_FAIL:
//             return { loading: false, errorr: action.payload }
//         case USER_UPDATE_RESET:
//             return {}
//         default:
//             return state
//     }
// }

// medecin ps

export const medeciPsLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case MEDECIN_PS_LOGIN_REQUEST:
      return { loading: true };

    case MEDECIN_PS_LOGIN_SUCCESS:
      return { loading: false, medecinPSInfo: action.payload };

    case MEDECIN_PS_LOGIN_FAIL:
      return { loading: false, error: action.payload };

    case MEDECIN_PS_LOGOUT:
      return {};
    case MEDECIN_PS_DETAIL_RESET:
      return {};

    default:
      return state;
  }
};
